import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=4514469a&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"
import style0 from "./BoardView.vue?vue&type=style&index=0&id=4514469a&prod&lang=scss&scoped=true"
import style1 from "./BoardView.vue?vue&type=style&index=1&id=4514469a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514469a",
  null
  
)

export default component.exports